import React, { useState } from 'react';
import { Modal } from 'antd';
import { customFleets } from 'shared';
import { PitstopSelect } from 'shared/PitstopUI/PitstopSelect';
import { AppStore, ShopStore } from 'stores';
import { CarStore } from 'stores';
import { Logger } from 'stores/Classes';

interface SubLocationSelectionModalProps {
  carIds: any[];
  onSuccess?: (locationId: any) => void;
  visible: boolean;
  onClose: () => void;
}

// Standalone component that can be rendered directly
export const SubLocationSelectionModal = ({
  carIds,
  onSuccess,
  visible,
  onClose,
}: SubLocationSelectionModalProps) => {
  const [selectedLocationId, setSelectedLocationId] = useState(null);
  const [loading, setLoading] = useState(false);
  const isTimHortonsFleet = customFleets.timhortons.includes(
    ShopStore.currentShop.parentShopId || ShopStore.currentShop.id
  );

  const handleOk = async () => {
    setLoading(true);
    try {
      await Promise.all(
        carIds.map(async (carId) => {
          await CarStore.updateCar(
            { id: carId },
            {
              meta: {
                assetLocationId: selectedLocationId,
              },
            }
          );
        })
      );

      isTimHortonsFleet
        ? AppStore.addNotification('Resident yard updated successfully')
        : AppStore.addNotification('Sub-locations updated successfully');

      if (onSuccess) {
        onSuccess(selectedLocationId);
      }
      onClose();
    } catch (error) {
      isTimHortonsFleet
        ? Logger.error(`Error updating resident yard: ${error}`)
        : Logger.error(`Error updating sub-location: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  return visible ? (
    <Modal
      title={isTimHortonsFleet ? 'Select Resident Yard' : 'Select Sub-location'}
      open={visible}
      okText="Save"
      cancelText="Cancel"
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={loading}
    >
      <PitstopSelect
        value={selectedLocationId}
        style={{ width: '100%' }}
        placeholder={
          isTimHortonsFleet ? 'Select a resident yard' : 'Select a sub-location'
        }
        id="sub-location-select"
        selectOptionDisplayField="label"
        selectOptionValueField="value"
        allowClear={true}
        options={(
          (ShopStore.shopSettings as any)?.result?.[0]?.settings?.locations ||
          []
        ).map((subLocation: any) => ({
          label: `${subLocation.code || ''} - ${subLocation.description || ''}`,
          value: subLocation.id,
        }))}
        onChange={(value: any) => {
          setSelectedLocationId(value);
        }}
        disabled={loading}
      />
    </Modal>
  ) : null;
};

export default SubLocationSelectionModal;
